export default __webpack_public_path__ + "static/media/mc-4-rMIN.6cfe750f.avif";